// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Checkbox_inputContainer__ibs8k","checkbox":"Checkbox_checkbox__DvvxB"};